import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux'

import {ConfigProvider} from 'antd'

import App from './App';

import {store} from '@/store'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#2FBD6A',
        },
      }}
    >
      <App />
    </ConfigProvider>
  </Provider>
);
